import { useEffect } from "react";

export default function useFixMobileClose(setFocusedInput) {
  // Fix for a bug in react-dates where for some reason prevents it closing on mobile
  useEffect(() => {
    if (!window) return;
    function handler({ target }) {
      const closeButton = document.querySelector(
        ".DateRangePicker_closeButton"
      );
      if (
        !closeButton ||
        (closeButton !== target && !closeButton.contains(target))
      )
        return;
      setFocusedInput(null);
    }

    window.addEventListener("click", handler);
    return () => {
      window.removeEventListener("click", handler);
    };
  }, [setFocusedInput]);
}
